// 2026-06-28 PR #37: centralized auth-header helper.
//
// Background: PR #34 (June 23) added Bearer-token auth to 11 patient-scoped
// API endpoints. The frontend updated only one call site (admin user list);
// every other call to /api/patients/* started silently 401-ing. Practitioners
// could see their patient list but could not open, save, or update any patient.
// External audit caught it; this helper makes the auth header impossible to
// forget on new call sites.
//
// localStorage key 'pp_auth' is set by AuthGate (frontend/src/components/AuthGate.js)
// on login and signup. Shape: { token: '<jwt>', user: { ... } }.

/**
 * Returns axios-style headers object with Bearer token if a session exists.
 * Returns an empty object if there's no logged-in session (callers can still
 * use this safely on public endpoints).
 */
export function getAuthHeaders() {
  try {
    const stored = localStorage.getItem("pp_auth");
    if (!stored) return {};
    const data = JSON.parse(stored);
    if (data && data.token) {
      return { Authorization: `Bearer ${data.token}` };
    }
  } catch (e) {
    // localStorage may be disabled, JSON may be corrupt — fail open.
  }
  return {};
}

/** Returns true if a logged-in session token is present. */
export function isAuthenticated() {
  return !!getAuthHeaders().Authorization;
}
